<template>
  <v-container fluid class="pa-2">

    <div class="traka">
      <h2 class="naslov">Korisnici firme</h2>
      <div class="podatak">{{ nazivFirme }}</div>
      <div class="brojke">
        <div class="brojka">
          <div class="v">{{ brojAktivnih }}</div>
          <div class="o">aktivnih</div>
        </div>
        <div class="brojka" :class="{istice: brojNeaktivnih > 0}">
          <div class="v">{{ brojNeaktivnih }}</div>
          <div class="o">neaktivnih</div>
        </div>
      </div>
    </div>

    <v-card tile>
      <div class="alati">
        <v-text-field
          v-model="trazi"
          label="Traži po imenu ili e-mailu"
          dense
          hide-details
          clearable
          append-icon="mdi-magnify"
          style="max-width:280px"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn small text color="primary" :loading="ucitavam" @click="dohvati">
          <v-icon small left>mdi-refresh</v-icon>Osvježi
        </v-btn>
      </div>

      <v-divider></v-divider>

      <div v-if="ucitavam" class="text-center py-8">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>

      <div v-else-if="prikazani.length === 0" class="prazno">
        Nema korisnika po ovim uvjetima.
      </div>

      <div v-else>
        <div v-for="k in prikazani" :key="k.id" class="redak">
          <div class="pojas" :class="k.Activ ? 'aktivan' : 'neaktivan'"></div>

          <div class="sredina">
            <div class="ime">
              {{ k.First }} {{ k.Last }}
              <span v-if="k.glavniAdmin" class="znak glavni">glavni administrator</span>
              <span v-else-if="k.adminFirme" class="znak adm">admin firme</span>
              <span v-if="k.id === mojId" class="znak ja">Vi</span>
            </div>
            <div class="meta">
              {{ k.email }}
              <span v-if="!k.emailConfirmed" class="tocka">·</span>
              <span v-if="!k.emailConfirmed" class="orange--text text--darken-3">e-mail nije potvrđen</span>
            </div>
          </div>

          <div class="desna">
            <span class="stanje" :class="k.Activ ? 'da' : 'ne'">
              {{ k.Activ ? 'aktivan' : 'neaktivan' }}
            </span>

            <!-- Glavnog administratora ne dira admin firme, a sebe se ne
                 deaktivira - posluzitelj to ionako odbija, ali gumb koji ne
                 radi samo zbunjuje. -->
            <v-btn
              v-if="smijemMijenjati(k)"
              x-small
              text
              :color="k.Activ ? 'red darken-2' : 'green darken-2'"
              :loading="radim === k.id"
              @click="promijeniAktivnost(k)"
            >{{ k.Activ ? 'Deaktiviraj' : 'Aktiviraj' }}</v-btn>

            <v-btn
              v-if="smijemLozinku(k)"
              x-small
              text
              color="primary"
              @click="otvoriLozinku(k)"
            >Nova lozinka</v-btn>
          </div>
        </div>
      </div>
    </v-card>

    <div class="mt-3">
      <v-btn small color="green" @click="natrag">Natrag</v-btn>
    </div>

    <!-- Nova lozinka -->
    <v-dialog v-model="lozinkaDijalog" max-width="460px" persistent>
      <v-card>
        <v-card-title class="blue darken-4 white--text py-3">
          <span class="subtitle-1">Nova lozinka</span>
        </v-card-title>
        <v-card-text class="pt-4">
          <div class="mb-3">
            <b>{{ odabrani.First }} {{ odabrani.Last }}</b>
            <div class="caption grey--text">{{ odabrani.email }}</div>
          </div>

          <v-text-field
            v-model="novaLozinka"
            label="Nova lozinka"
            :type="vidiLozinku ? 'text' : 'password'"
            :append-icon="vidiLozinku ? 'mdi-eye-off' : 'mdi-eye'"
            dense
            outlined
            autocomplete="new-password"
            :error-messages="zapreka ? [zapreka] : []"
            @click:append="vidiLozinku = !vidiLozinku"
          ></v-text-field>

          <v-text-field
            v-model="potvrdaLozinke"
            label="Ponovi lozinku"
            :type="vidiLozinku ? 'text' : 'password'"
            dense
            outlined
            autocomplete="new-password"
          ></v-text-field>

          <div class="caption grey--text">
            Najmanje 8 znakova, bez razmaka. Korisnik se sljedeći put prijavljuje
            novom lozinkom — javite mu je.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="zatvoriLozinku">Odustani</v-btn>
          <v-btn
            color="primary"
            :disabled="!!zapreka || !novaLozinka"
            :loading="radim === odabrani.id"
            @click="spremiLozinku"
          >Spremi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="poruka.vidi" :color="poruka.boja" :timeout="5000">
      {{ poruka.tekst }}
    </v-snackbar>
  </v-container>
</template>

<script>
import FirmaKorisniciService from '@/services/FirmaKorisniciService'

export default {
  name: 'firmakorisnici',
  data () {
    return {
      korisnici: [],
      ucitavam: false,
      radim: 0,
      trazi: '',
      lozinkaDijalog: false,
      odabrani: {},
      novaLozinka: '',
      potvrdaLozinke: '',
      vidiLozinku: false,
      poruka: {vidi: false, tekst: '', boja: 'success'}
    }
  },
  async mounted () {
    await this.dohvati()
  },
  computed: {
    mojId () {
      return this.$store.getters.NeedUserID
    },
    nazivFirme () {
      const c = this.$store.state.companyActiv
      return c && c.CompanyName ? c.CompanyName : ''
    },
    jaSamGlavniAdmin () {
      const u = this.$store.state.user
      return !!(u && u.Admin === true)
    },
    brojAktivnih () {
      return this.korisnici.filter(k => k.Activ).length
    },
    brojNeaktivnih () {
      return this.korisnici.filter(k => !k.Activ).length
    },
    prikazani () {
      const t = (this.trazi ? this.trazi : '').toLowerCase().trim()
      if (!t) { return this.korisnici }
      return this.korisnici.filter(k =>
        ((k.First || '') + ' ' + (k.Last || '') + ' ' + (k.email || '')).toLowerCase().indexOf(t) !== -1)
    },
    // Lozinka se provjerava na ekranu samo da operater odmah vidi zapreku;
    // posluzitelj je ionako provjerava ponovno.
    zapreka () {
      const l = this.novaLozinka ? String(this.novaLozinka) : ''
      if (!l) { return '' }
      if (l.length < 8) { return 'Lozinka mora imati barem 8 znakova.' }
      if (/\s/.test(l)) { return 'Lozinka ne smije sadržavati razmak.' }
      if (this.odabrani.email && l.toLowerCase() === String(this.odabrani.email).toLowerCase()) {
        return 'Lozinka ne smije biti jednaka e-mail adresi.'
      }
      if (this.potvrdaLozinke && l !== this.potvrdaLozinke) { return 'Lozinke se ne podudaraju.' }
      if (!this.potvrdaLozinke) { return 'Ponovite lozinku.' }
      return ''
    }
  },
  methods: {
    async dohvati () {
      try {
        this.ucitavam = true
        const {data} = await FirmaKorisniciService.popis({CompanyId: this.$store.state.companyid})
        this.korisnici = data.korisnici ? data.korisnici : []
      } catch (err) {
        const o = err && err.response && err.response.data
        this.poruka = {vidi: true, boja: 'error',
          tekst: o && o.error ? o.error : 'Popis korisnika nije dohvaćen.'}
        this.korisnici = []
      } finally {
        this.ucitavam = false
      }
    },
    // Glavnog administratora mijenja samo glavni administrator; sebe se ne
    // deaktivira.
    smijemMijenjati (k) {
      if (k.id === this.mojId) { return false }
      if (k.glavniAdmin && !this.jaSamGlavniAdmin) { return false }
      return true
    },
    smijemLozinku (k) {
      if (k.glavniAdmin && !this.jaSamGlavniAdmin) { return false }
      return true
    },
    async promijeniAktivnost (k) {
      const pitanje = k.Activ
        ? 'Deaktivirati korisnika ' + k.First + ' ' + k.Last + '? Neće se moći prijaviti.'
        : 'Aktivirati korisnika ' + k.First + ' ' + k.Last + '?'
      if (!confirm(pitanje)) { return }
      try {
        this.radim = k.id
        const {data} = await FirmaKorisniciService.aktivan(k.id, {
          CompanyId: this.$store.state.companyid,
          Activ: !k.Activ
        })
        k.Activ = data.Activ
        this.poruka = {vidi: true, tekst: data.message, boja: 'success'}
      } catch (err) {
        const o = err && err.response && err.response.data
        this.poruka = {vidi: true, boja: 'error',
          tekst: o && o.error ? o.error : 'Izmjena nije spremljena.'}
      } finally {
        this.radim = 0
      }
    },
    otvoriLozinku (k) {
      this.odabrani = k
      this.novaLozinka = ''
      this.potvrdaLozinke = ''
      this.vidiLozinku = false
      this.lozinkaDijalog = true
    },
    zatvoriLozinku () {
      this.lozinkaDijalog = false
      // Lozinka ne ostaje u pamcenju ekrana nakon zatvaranja.
      this.novaLozinka = ''
      this.potvrdaLozinke = ''
      this.odabrani = {}
    },
    async spremiLozinku () {
      if (this.zapreka) { return }
      try {
        this.radim = this.odabrani.id
        const {data} = await FirmaKorisniciService.lozinka(this.odabrani.id, {
          CompanyId: this.$store.state.companyid,
          password: this.novaLozinka
        })
        this.poruka = {vidi: true, boja: 'success',
          tekst: data.message + ' Javite je korisniku ' + data.email + '.'}
        this.zatvoriLozinku()
      } catch (err) {
        const o = err && err.response && err.response.data
        this.poruka = {vidi: true, boja: 'error',
          tekst: o && o.error ? o.error : 'Lozinka nije promijenjena.'}
      } finally {
        this.radim = 0
      }
    },
    natrag () {
      this.$router.push({name: 'appsettings'}).catch(() => {})
    }
  }
}
</script>

<style scoped>
.traka {
  background: #0d47a1;
  color: #fff;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  border-radius: 4px 4px 0 0;
}
.naslov { font-size: 18px; font-weight: 500; margin: 0; }
.podatak { font-size: 13px; opacity: .9; }
.brojke { display: flex; gap: 20px; margin-left: auto; flex-wrap: wrap; }
.brojka { text-align: right; }
.brojka .v { font-size: 18px; font-weight: 700; line-height: 1.1; }
.brojka .o { font-size: 11px; opacity: .85; }
.brojka.istice .v { color: #ff8a80; }

.alati { display: flex; gap: 10px; align-items: center; padding: 8px 12px; flex-wrap: wrap; }

.redak {
  display: flex;
  gap: 10px;
  padding: 9px 12px;
  border-bottom: 1px solid #f0f3f6;
  align-items: center;
}
.redak:last-child { border-bottom: none; }
.redak:hover { background: #fafcff; }

.pojas { width: 4px; flex: 0 0 4px; align-self: stretch; border-radius: 2px; }
.pojas.aktivan { background: #2e7d32; }
.pojas.neaktivan { background: #bdbdbd; }

.sredina { flex: 1 1 auto; min-width: 0; }
.ime { font-weight: 500; }
.meta { font-size: 12px; color: #5f6b7a; margin-top: 2px; }
.meta .tocka { opacity: .5; margin: 0 4px; }

.znak {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 11px;
  margin-left: 6px;
  white-space: nowrap;
}
.znak.glavni { background: #ffebee; color: #c62828; }
.znak.adm { background: #e8eaf6; color: #3949ab; }
.znak.ja { background: #e8f5e9; color: #2e7d32; }

.desna { flex: 0 0 auto; display: flex; align-items: center; gap: 6px; }
.stanje { font-size: 12px; min-width: 74px; text-align: right; }
.stanje.da { color: #2e7d32; }
.stanje.ne { color: #9e9e9e; }

.prazno { text-align: center; padding: 34px 12px; color: #5f6b7a; }

@media (max-width: 600px) {
  .redak { flex-wrap: wrap; }
  .desna { width: 100%; justify-content: flex-start; padding-left: 14px; }
  .brojke { width: 100%; margin-left: 0; justify-content: space-between; }
}
</style>
